import colors from '@sportninja/common/constants/appColors'
import React from 'react'

interface PlusCircleIconProps {
  color?: string
  size?: number
}

/**
 * Plus circle icon for add division button
 */
const PlusCircleIcon: React.FC<PlusCircleIconProps> = ({
  color = colors.PRIMARY,
  size = 24,
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
    >
      <path
        d='M12 2.00049C6.48 2.00049 2 6.48049 2 12.0005C2 17.5205 6.48 22.0005 12 22.0005C17.52 22.0005 22 17.5205 22 12.0005C22 6.48049 17.52 2.00049 12 2.00049ZM16 13.0005H13V16.0005C13 16.5505 12.55 17.0005 12 17.0005C11.45 17.0005 11 16.5505 11 16.0005V13.0005H8C7.45 13.0005 7 12.5505 7 12.0005C7 11.4505 7.45 11.0005 8 11.0005H11V8.00049C11 7.45049 11.45 7.00049 12 7.00049C12.55 7.00049 13 7.45049 13 8.00049V11.0005H16C16.55 11.0005 17 11.4505 17 12.0005C17 12.5505 16.55 13.0005 16 13.0005Z'
        fill={color}
      />
    </svg>
  )
}

export default PlusCircleIcon
